import React from 'react';

const ReportRecapAvgMMCell = ({ value }) => {
  if (parseFloat(value) < 50) return <div className="font-red">{value}</div>;
  if (parseFloat(value) >= 70) return <div className="font-green">{value}</div>;
  return <div>{value}</div>;
};

export default ReportRecapAvgMMCell;
